import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const SyaratDaftarService = {}

SyaratDaftarService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/syaratdaftar',
        method: 'get',
        params: {
            "id_kelas_sekolah":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default SyaratDaftarService;
